import {
  ApiResponse,
  TokenData,
  ILeadQuality,
  ILeadQualityReason,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class LeadQualityService extends ApiService {
  public async loadAllQuality() {
    const url = `${this.apiDomain}/api/lead-quality`;

    const resposne = await http.get<ApiResponse<ILeadQuality[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateQuality(data: ILeadQuality, id?: string) {
    const url = `${this.apiDomain}/api/lead-quality/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async loadAllReason() {
    const url = `${this.apiDomain}/api/lead-quality/reason`;

    const resposne = await http.get<ApiResponse<ILeadQualityReason[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateQualityReason(data: ILeadQualityReason, id?: string) {
    const url = `${this.apiDomain}/api/lead-quality/reason/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createQualityReason(data: ILeadQualityReason, id?: string) {
    const url = `${this.apiDomain}/api/lead-quality/reason`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteReason(id?: string) {
    const url = `${this.apiDomain}/api/lead-quality/reason/${id}`;

    const response = await http.remove<ApiResponse<ILeadQualityReason>>(
      url,
      this.store
    );
    return response.data;
  }
}
